import { useMutation, useQueryClient, MutationOptions } from "react-query";
import { post, API_URL, APIResponse, APIError } from "../api";

export interface AddToCartPayload {
  product_id: string;
  quantity: number;
}

export function useAddToCart(
  options?: MutationOptions<APIResponse<any>, APIError, AddToCartPayload>
) {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError, error, data } = useMutation(
    (payload: AddToCartPayload) => {
      return post(`${API_URL}/commerce/cart/add`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.refetchQueries("cart");
        options?.onSuccess?.(...args);
      },
    }
  );

  return {
    addToCart: mutate,
    addingToCart: isLoading,
    isAddCartError: isError,
    addCartError: error,
    addCartResponse: data,
  };
}
